<template>
  <ul class="list">
    <li v-for="(value, key) in stats" :key="key" class="list__item">
      <span class="list__label"> {{ key }} </span>
      <span class="list__value"> {{ value }} </span>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    stats: {
      required: true,
      type: Object,
    },
  },
  methods: {
    getStyle(item) {
      return {
        width: `${item.value / 3}%`,
        backgroundColor: item.color,
      };
    },
  },
};
</script>

<style lang="sass" scoped>
.list
  padding: 0
  list-style: none

  &__item
    display: flex
    align-items: center
    justify-content: space-between
    margin: 6px
    padding: 7px 24px
    background-color: $geekblue-1
    border-radius: 8px

  &__label
    font-size: $font-small

  &__value
    color: $gray-8
    font-weight: 600
    font-size: $font-medium
</style>
